import React, { useEffect, useRef, useState } from 'react';
import { IBwjAnnouncementBannerProps, IShowAnnouncementBannerArgs } from './props';
import { Dialog, DialogFooter, DialogType, FontIcon, FontSizes, getTheme, MessageBarType } from '@fluentui/react';
import { BwjButton, BwjButtonType } from '../bwj-button';
import { getBwjAnnouncementBannerColorScheme } from './color';
import $ from 'jquery';

export const PRIVATE_ANNOUNCEMENT_DIALOG: React.FunctionComponent<IBwjAnnouncementBannerProps> = (props) => {
  const { invokeShowAnnouncement, linkHandler } = props;
  const [showDialog, setShowDialog] = useState(false);
  const messageRef = useRef<HTMLParagraphElement | null>(null);
  const theme = getTheme();
  const dialogProps = useRef<IShowAnnouncementBannerArgs | undefined>(undefined);
  const color = getBwjAnnouncementBannerColorScheme(dialogProps.current?.messageType ?? MessageBarType.info);

  // on show dialog invoked
  useEffect(() => {
    if(invokeShowAnnouncement === undefined || invokeShowAnnouncement.inaccessible()) { return; }
    invokeShowAnnouncement.getArgs() && setShowDialog(true);
  }, [invokeShowAnnouncement]);

  // on every redraw, wire up link event handlers if needed
  useEffect(() => {
    if(showDialog === false || linkHandler === undefined) { return () => {}; }

    let msg = messageRef.current;
    const cancelToken = window.setTimeout(() => {
      msg = messageRef.current;
      if(msg === null) { return; }

      $(msg).children('a').on('click', (e) => {
        linkHandler($(e.target).attr('href') ?? '#');
        e.stopPropagation();
        e.preventDefault();
      });
    }, 50);

    return () => {
      window.clearTimeout(cancelToken);
      if(!!msg) {
        $(msg).children('a').off('click');
      }
    };
  }, [showDialog, linkHandler]);

  const onDismiss = () => setShowDialog(false);

  const dp = dialogProps.current;
  return (
    <>
      {!!dp &&
      <Dialog
        hidden={showDialog === false}
        onDismiss={onDismiss}
        dialogContentProps={{ type: DialogType.normal }}
        modalProps={{
          isBlocking: false,
          styles: {
            main: {
              width: '100%',
              maxWidth: 500,
            },
            scrollableContent: {
              fontSize: theme.fonts.medium.fontSize,
              '& > div': {
                borderTop: `0.5em solid ${color.main}`,
                backgroundColor: color.background,
              },
              '& .ms-Dialog-header': {
                display: 'none',
              },
              '& .ms-Dialog-inner': {
                padding: '1.5em',
              },
            },
          }
        }}
      >
        {!!dp.icon &&
        <FontIcon
          iconName={dp.icon}
          style={{
            fontSize: FontSizes.superLarge,
            color: color.main,
          }}
        />}
        <p
          ref={messageRef}
          dangerouslySetInnerHTML={dp.renderAsHtml === true ? { __html: dp.message } : undefined}
        >
          {dp.renderAsHtml !== true ? dp.message : null}
        </p>
        <DialogFooter
        styles={{
          actions: {
            fontSize: 16,
            marginTop: '2em',
          }
        }}
        >
          <BwjButton
            buttonStyle={BwjButtonType.DefaultStandard}
            text={props.closeDialogButtonText ?? 'Close'}
            onClick={onDismiss}
          />
        </DialogFooter>
      </Dialog>}
    </>
  );
};
